import React, {useState} from 'react';
import {Panel} from 'reactflow';
import {useTranslation} from 'react-i18next';

function EdgeSample({color, dashed, opacity = 1}: {color: string; dashed?: boolean; opacity?: number}): JSX.Element {
    return (
        <svg width="36" height="14" viewBox="0 0 36 14" fill="none" style={{flexShrink: 0, opacity}}>
            <line x1="2" y1="7" x2="28" y2="7" stroke={color} strokeWidth="2" strokeDasharray={dashed ? '5 4' : undefined} />
            <polygon points="28,3 36,7 28,11" fill={color} />
        </svg>
    );
}

function NodeSample({color}: {color: string}): JSX.Element {
    return <span className="rf-legend__node-sample" style={{borderColor: color}} />;
}

export default function FlowLegend(): JSX.Element {
    const {t} = useTranslation();
    const [open, setOpen] = useState(false);

    return (
        <Panel position="bottom-left" className="rf-legend">
            <button className="rf-legend__toggle nodrag" onClick={() => setOpen((v) => !v)}>
                <span className="rf-legend__toggle-icon">?</span>
                {t('presEditPage.rules.legend.title')}
            </button>

            {open && (
                <div className="rf-legend__body nodrag">
                    <p className="rf-legend__section">{t('presEditPage.rules.legend.nodeTypes')}</p>
                    <ul className="rf-legend__list">
                        <li>
                            <NodeSample color="#d1d5db" />
                            <span>{t('presEditPage.rules.legend.slideNode')}</span>
                        </li>
                        <li>
                            <NodeSample color="#93c5fd" />
                            <span>{t('presEditPage.rules.legend.questionNode')}</span>
                        </li>
                        <li>
                            <NodeSample color="#377ea9" />
                            <span>{t('presEditPage.rules.legend.actionNode')}</span>
                        </li>
                    </ul>

                    <p className="rf-legend__section">{t('presEditPage.rules.legend.edgeTypes')}</p>
                    <ul className="rf-legend__list">
                        <li>
                            <EdgeSample color="#9ca3af" />
                            <span>{t('presEditPage.rules.legend.seqEdge')}</span>
                        </li>
                        <li>
                            <EdgeSample color="#d1d5db" dashed />
                            <span>{t('presEditPage.rules.legend.linkEdge')}</span>
                        </li>
                        <li>
                            <EdgeSample color="#377ea9" />
                            <span>{t('presEditPage.rules.legend.ruleEdge')}</span>
                        </li>
                        <li>
                            <EdgeSample color="#377ea9" dashed opacity={0.85} />
                            <span>{t('presEditPage.rules.legend.ghostEdge')}</span>
                        </li>
                    </ul>

                    <p className="rf-legend__section">{t('presEditPage.rules.legend.ruleActions')}</p>
                    <ul className="rf-legend__list rf-legend__list--actions">
                        <li>
                            <span className="rf-legend__badge rf-legend__badge--jump">{t('presEditPage.rules.legend.jump')}</span>
                            <span>{t('presEditPage.rules.legend.jumpDesc')}</span>
                        </li>
                        <li>
                            <span className="rf-legend__badge rf-legend__badge--hide">{t('presEditPage.rules.legend.hide')}</span>
                            <span>{t('presEditPage.rules.legend.hideDesc')}</span>
                        </li>
                        <li>
                            <span className="rf-legend__badge rf-legend__badge--show">{t('presEditPage.rules.legend.show')}</span>
                            <span>{t('presEditPage.rules.legend.showDesc')}</span>
                        </li>
                    </ul>

                    <p className="rf-legend__section">{t('presEditPage.rules.legend.howTo')}</p>
                    <ul className="rf-legend__list rf-legend__list--tips">
                        <li>{t('presEditPage.rules.legend.tip1')}</li>
                        <li>{t('presEditPage.rules.legend.tip2')}</li>
                        <li>{t('presEditPage.rules.legend.tip3')}</li>
                        <li>{t('presEditPage.rules.legend.tip4')}</li>
                    </ul>
                </div>
            )}
        </Panel>
    );
}
